import { all, takeLatest, put, select, call } from 'redux-saga/effects';

import {
  types,
  fetchQuestionFailure,
  fetchQuestionSuccess,
  getActiveTab,
  fetchQuestionsNextPageFailure,
  getQuestions,
  fetchQuestionsNextPageSuccess,
  getCurrentPages,
  fetchQuestions,
} from '@coconut/services/redux/questionList';
import { getRole, getUserId } from '@coconut/services/redux/profile';
import { goToQuestionChatroomByID } from '@coconut/scenes/Chat/services/redux/selectQuestion';

import { TUTOR } from '@coconut/constants/userRole';
import { ONGOING, HISTORY } from '@coconut/constants/questionListTabNames';
import { ON_GOING, UNRATE, FINISHED } from '@coconut/constants/questions';

import { getTutorQuestionsHistory } from '@coconut/services/apis/tutor';
import { setModeOfTutorHome } from '@coconut/services/redux/location';
import { CHATROOM_MODE } from '@coconut/constants/modeOfTutorHome';

const STATUS = {
  [ONGOING]: [ON_GOING],
  [HISTORY]: [UNRATE, FINISHED],
};

export function* tutorQuestions(tab, uid) {
  try {
    const {
      data: { questions, total_pages: totalPages },
    } = yield call(getTutorQuestionsHistory, {
      uid,
      statuses: STATUS[tab],
    });

    yield put(fetchQuestionSuccess(questions, totalPages));
  } catch (err) {
    yield put(fetchQuestionFailure(err));
  }
}

export function* studentQuestions() {}

export function* changeTabFlow() {
  yield put(fetchQuestions());
}

export function* fetchQuestionsFlow() {
  const role = yield select(getRole);
  const uid = yield select(getUserId);
  const tab = yield select(getActiveTab);

  if (role === TUTOR) {
    yield call(tutorQuestions, tab, uid);
  } else {
    yield call(studentQuestions, tab, uid);
  }
}

export function* selectQuestionFlow(action) {
  const { qid } = action.payload;

  yield put(goToQuestionChatroomByID(qid));
  yield put(setModeOfTutorHome(CHATROOM_MODE));
}

export function* fetchQuestionsNextPageFlow() {
  try {
    const tab = yield select(getActiveTab);
    const uid = yield select(getUserId);
    const currentPages = yield select(getCurrentPages);
    const nextPage = currentPages + 1;

    const {
      data: { questions },
    } = yield call(getTutorQuestionsHistory, {
      uid,
      statuses: STATUS[tab],
      page: nextPage,
    });

    const allQuestions = yield select(getQuestions);
    yield put(
      fetchQuestionsNextPageSuccess([...allQuestions, ...questions], nextPage)
    );
  } catch (err) {
    yield put(fetchQuestionsNextPageFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(types.CHANGE_TAB, changeTabFlow),
    takeLatest(types.SELECT_QUESTION, selectQuestionFlow),
    takeLatest(types.FETCH_QUESTIONS_NEXT_PAGE, fetchQuestionsNextPageFlow),
    takeLatest(types.FETCH_QUESTIONS, fetchQuestionsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/questionList.js